export default __webpack_public_path__ + "static/media/ma.9fc88183.svg";